let _loadPromise = null

export const loadGoogleMaps = () => {
  // Already fully loaded
  if (window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve()
  }

  // Already loading — return same promise
  if (_loadPromise) return _loadPromise

  _loadPromise = new Promise((resolve) => {
    const apiKey = process.env.REACT_APP_GOOGLE_API_KEY

    if (!apiKey) {
      console.warn("loadGoogleMaps: REACT_APP_GOOGLE_API_KEY is not set")
      _loadPromise = null
      return resolve()
    }

    // If script already in DOM (added by another instance), just wait for it
    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
      const poll = (tries = 100) => {
        if (window.google?.maps?.places) {
          window.dispatchEvent(new Event("googleMapsReady"))
          return resolve()
        }
        if (tries > 0) setTimeout(() => poll(tries - 1), 100)
        else resolve()
      }
      poll()
      return
    }

    const callbackName = "__googleMapsInitCallback"
    window[callbackName] = () => {
      delete window[callbackName]
      window.dispatchEvent(new Event("googleMapsReady"))
      resolve()
    }

    const script = document.createElement("script")
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=${callbackName}&v=weekly`
    script.async = true
    script.defer = true

    script.onerror = () => {
      console.error("loadGoogleMaps: script failed to load")
      delete window[callbackName]
      _loadPromise = null
      resolve()
    }

    document.head.appendChild(script)
  })

  return _loadPromise
}

export const isGoogleMapsReady = () =>
  !!(window.google && window.google.maps && window.google.maps.places)
